<template>
	<div class="dropdown-row-wrapper">
        <button-list
        class="dropdown-row"
        :selected="selectedOption === option.id"
        :label="option.text"
        :icon="option.icon ?? 'brokenImage'"
		:iconBackgroundColor="categoryColor"
        variant="secondary"
        @clicked="emit('clicked', option.id)"/>
	</div>
</template>

<script setup>
import ButtonList from '@/components/generic/buttons/List'
/* Vue */
import { computed } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
const { getAppThemeMode } = mapGetters()

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@selectedOption { String }
@option { Array } each item is an Object
	- id { String, Number }
	- text { String }
	- icon { String } - in case icon is deep in the icons folder this will also bring the folder name, example: 'flags/AED-flag'
	- backgroundColor { String }
*/
const props = defineProps({
	selectedOption: [String, Number, Boolean],
	option: Object
})

const categoryColor = computed(() => {
    if (!props.option.backgroundColor) return 'var(--secondary-light-2)'
    return getAppThemeMode.value === 'dark' && props.option.darkBackgroundColor ? props.option.darkBackgroundColor : props.option.backgroundColor
})
</script>

<style lang="scss" scoped>
.dropdown-row-wrapper {
    width: 100%;

    .dropdown-row {
        justify-content: flex-start;

        width: 100%;
    }
}
</style>
